/** 同一神策组织下区分数据流：vas / cargowarex-client / cargowarex-admin */
export type TrackingAppName = 'vas' | 'cargowarex-client' | 'cargowarex-admin'

export interface TrackingClientOptions {
  enabled?: boolean
  token: string
  apiHost: string
  appName: TrackingAppName
  endpoint: string
  appVersion?: string
  env?: string
  platform?: string
  debug?: boolean
  autoCapture?: boolean
  isSinglePageApp?: boolean
  enableClickTrack?: boolean
}

export interface TrackingUserLike {
  id: string
  realName?: string
  username?: string
  tenantId?: string
  tenantName?: string
  branchId?: string
  branchName?: string
  roleType?: number
}

export interface TrackingIdentifyExtras {
  tenantId?: string
  tenantName?: string
  branchId?: string
  branchName?: string
}

export interface TabClickTrackingOptions {
  tabSelector?: string
  titleSelector?: string
  /** 自身或祖先含此属性则跳过（如路由跳转型 tab，避免与 PageView 重复） */
  ignoreAttribute?: string
}

export const TrackingEvents = {
  UserLogin: 'UserLogin',
  UserLogout: 'UserLogout',
  ButtonClick: 'ButtonClick',
  FormSubmit: 'FormSubmit',
  TabSwitch: 'TabSwitch'
} as const

export type TrackingEventName = (typeof TrackingEvents)[keyof typeof TrackingEvents]

/** VAS 来源枚举，跳转 URL 使用 ?source= 对应值 */
export const TrackingSource = {
  Family: 'family',
  AppCenter: 'app-center',
  Direct: 'direct'
} as const

export type TrackingSourceValue = (typeof TrackingSource)[keyof typeof TrackingSource]

export interface AppTracking {
  initTracking(): void
  syncTrackingIdentify(user: TrackingUserLike | null | undefined, extras?: TrackingIdentifyExtras): void
  syncTrackingSource(): TrackingSourceValue | null
  resetTracking(): void
  trackEvent(eventName: string, properties?: Record<string, unknown>): void
  setupTabClickTracking(options?: TabClickTrackingOptions): () => void
}
